import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import SectionWrapper from "@/partials/sections/Section/SectionWrapper";
import React from "react";

export default function PractitionersInfo() {
  return (
    <SectionWrapper extraClass={"pb-8 md:pb-[40px] pl-0 md:pl-0"}>
      <Headline
        text={`Accompanied by`}
        subText={`thousands of Practitioners`}
        extraClass={"text-white text-4xl md:text-4xl font-bold pb-3"}
      />

      <Description
        text={`This trust could be built over years of service, successful
          surgeries, positive patient outcomes, and a commitment to
                ethical practices.`}
        extraClass={"text-white opacity-70 max-w-md"}
      />
    </SectionWrapper>
  );
}
